import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M15 5.766a3.763 3.763 0 00-3.77-3.757c-1.37 0-2.57.73-3.23 1.822a3.77 3.77 0 00-3.23-1.822A3.763 3.763 0 001 5.766a3.74 3.74 0 001.19 2.738h-.001L7.914 14l5.898-5.496h-.002A3.739 3.739 0 0015 5.766" fill="#474747" /></svg>;
}

export default SvgComponent;